<nz-layout class="container">
  <nz-sider
    #sider
    nzWidth="300px"
    [nzCollapsedWidth]="isMobile ? 0 : 70"
    [nzCollapsed]="isMobile"
  >
    <az-blc-sidenav
      #sidenav
      [version]="version"
      [collapsed]="sider.nzCollapsed"
      (onColapse)="sider.setCollapsed(!sider.nzCollapsed)"
    />
  </nz-sider>
  <nz-layout>
    <nz-header>
      <az-blc-header
        [collapsed]="sider.nzCollapsed"
        [isMobile]="isMobile"
        (onColapse)="sider.setCollapsed(!sider.nzCollapsed)"
      />
    </nz-header>
    <nz-content *ngIf="!sidenav.isLoading$.value">
      <router-outlet #outlet />
    </nz-content>
  </nz-layout>
</nz-layout>
